<div class="modal-header">
  <h2 class="modal-title">{{title | translate}}</h2>
  <button type="button" class="btn-close" aria-label="Close" (click)="buttonClicked(false)">
  </button>
</div>

<div class="modal-body">
  <div class="row justify-content-center" *ngFor="let language of languages">
    <div class="col-md-6 radio-container">
      <input class="radio-input k-radio" id="{{language.name}}" type="radio" name="answer" [checked]="selectedLanguage === language.code" (click)="setLanguage(language.code)">
      <label class="radio-label" for="{{language.name}}"  (click)="setLanguage(language.code)">
        {{language.name}}
        <img src="assets/img/country-flags/language-flags/language-{{language.code}}.svg" class="language-ico-flag"/>
      </label>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn link-btn" (click)="buttonClicked(false)">
    <i class="app-icon icon icon-return icon-lg me-2"></i> 
    {{cancelButton | translate}}
  </button>
  <button type="button" class="btn primary-btn" (click)="buttonClicked(true)">
    {{successButton | translate}}
  </button>
</div>
